import React from 'react'
import { makeStyles } from '@material-ui/core'
import { FontSize, FontWeight } from 'theme/style'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: 'auto',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
    }
  },
  title: {
    ...theme.typography.h2,
    fontWeight: FontWeight.SemiBold,
  },
  description: {
    ...theme.typography.body1,
    marginTop: theme.spacing(1),
  },
  group: {
    marginTop: theme.spacing(2),
  },
  textContainer: {
    width: '100%'
  },
  actions: {
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2)
    }
  },
  disclaimer: {
    ...theme.typography.body2,
    fontSize: FontSize.BodyMini,
    marginTop: theme.spacing(4),
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 'auto',
    opacity: 0.5
  }
}))

interface SeparatorProps {
  title?: string
  description?: string
  actions?: React.ReactNode
  children?: React.ReactNode
  disclaimer?: React.ReactNode
}

const Separator = ({ ...props }: SeparatorProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.textContainer}>
          {props.title != null && <div className={classes.title}>{props.title}</div>}
          {props.description != null && <div className={classes.description}>{props.description}</div>}
        </div>
        <div className={classes.actions}>
          {props.actions}
        </div>
      </div>
      <div className={classes.group}>
        {props.children}
      </div>
      {/* {props.disclaimer != null &&
        <div className={classes.disclaimer}>
          {props.disclaimer}
        </div>
      } */}
    </div>
  )
}

export default Separator
